<script>
	import Select from "../Select.svelte";
	import Contact from "../Contact.svelte";
	import DatePicker from "../DatePicker.svelte";
	import Checkbox from "../Checkbox.svelte";

	import { model } from "../../stores";
	import { referralTypes, relationshipToClaimant, yesNoOptions } from "../../config";

	let disabled = true;
</script>

<section style="page-break-after: always">
	<h2>Your Contact Details</h2>

	<Contact
		bind:salutation={$model.Contact.Title}
		bind:firstName={$model.Contact.FirstName}
		bind:surname={$model.Contact.Surname}
		bind:emailAddress={$model.Contact.EmailAddresses[0].EmailAddress}
		bind:phoneNumber={$model.Contact.PhoneNumbers[0].PhoneNumber}
		bind:address={$model.Contact.Addresses[0]}
		{disabled}
	></Contact>

	<div class="form-row">
		<div class="form-group col-md-6">
			<label for="dateOfBirth"
				>Date of Birth. This will help us assess the appropriate award rate, in particular junior rates.</label
			>
			<DatePicker
				openOnClass="calendarpop"
				bind:formattedSelected={$model.DateOfBirth}
				{disabled}
				placeholder="e.g. 01/09/2020"
				start={new Date(1920, 1, 1)}
				end={new Date(2006, 1, 1)}
				id="dateOfBirth"
			/>
		</div>
	</div>

	<div class="form-row">
		<div class="form-group col-md-12">
			<label for="whereDidYouHear">Where did you hear about this class action?</label>
			<Select
				{disabled}
				id="whereDidYouHear"
				bind:value={$model.WhereDidYouHear}
				optionList={referralTypes}
				textProperty="name"
				valueProperty="name"
			></Select>
		</div>
	</div>

	{#if $model.UnderEighteen}
		<p>As you are currently below 18 years of age please provide the contact details of a parent or guardian</p>

		<div class="form-row">
			<div class="col-md-6">
				<h3>Contact Person</h3>
			</div>
		</div>

		<div class="form-row">
			<div class="form-group col-md-12">
				<label for="relationshipToClaimant">Relationship to you</label>
				<Select
					{disabled}
					id="relationshipToClaimant"
					bind:value={$model.RelationshipToClaimant}
					optionList={relationshipToClaimant}
					textProperty="name"
					valueProperty="name"
				></Select>
			</div>
		</div>

		<Contact
			bind:salutation={$model.GuardianContact.Title}
			bind:firstName={$model.GuardianContact.FirstName}
			bind:surname={$model.GuardianContact.Surname}
			bind:emailAddress={$model.GuardianContact.EmailAddresses[0].EmailAddress}
			bind:phoneNumber={$model.GuardianContact.PhoneNumbers[0].PhoneNumber}
			bind:address={$model.GuardianContact.Addresses[0]}
			{disabled}
			idPrefix="g"
		></Contact>
	{/if}

	<p>
		Shine Lawyers is being supported by the Retail and Fast Food Workers Union (RAFFWU) in the McDonald’s Breaks
		Class Action.
	</p>
	<p>
		Please confirm you acknowledge and consent to your information provided in this form being used in accordance
		with Shine Lawyers' Privacy Policy and that such information and data may be shared with RAFFWU.
	</p>

	<div class="form-row">
		<div class="form-group col-md-12">
			<Checkbox
				{disabled}
				bind:checked={$model.PrivacyPolicyConfirmed}
				label="I agree to the Shine Lawyers <a href='https://www.shine.com.au/privacy-policy' title='Privacy Policy' target='_blank'>Privacy Policy</a>"
				id="privacy"
			></Checkbox>
		</div>
	</div>

	<div class="form-row">
		<div class="form-group col-md-12">
			<label for="dataShareConsent">I consent to the data provided in this form being shared with RAFFWU</label>
			<Select
				{disabled}
				id="dataShareConsent"
				bind:value={$model.DataShareConsent}
				optionList={yesNoOptions}
				textProperty="label"
				valueProperty="label"
			></Select>
		</div>
	</div>
</section>
